
import { Component, Prop, VModel, Vue } from 'vue-property-decorator';

@Component
export default class VAdministrationTabs extends Vue {
    @VModel({ type: Number, default: 0 })
    public activeTabIndex!: number;

    @Prop({ type: Array, required: true })
    public tabs!: string[];

    isActive(idx: number) {
        return idx === this.activeTabIndex;
    }

    setActive(idx: number) {
        if (idx !== this.activeTabIndex) {
            return (this.activeTabIndex = idx);
        }
    }
}
